export default {
    el: {
        table: {
          emptyText: '暫無數據',
          confirmFilter: '篩選',
          resetFilter: '重置',
          clearFilter: '全部',
          sumText: '合計'
        },
        pagination: {
          goto: '前往第',
          pagesize: '條/頁',
          total: `共 {total} 條`,
          pageClassifier: '頁'
        }
      }
  };